import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import { Subscribe } from "unstated";
import deepEqual from "deep-equal";
import SrpContainer from "../../containers/SrpContainer";
import { SrpContext } from "../Filters/context";
import { Map } from "venuescanner-js/vanilla/components/map";
import { $ } from "venuescanner-js/tools/elemental";

class MapController extends React.Component {
  markers = [];

  static propTypes = {
    pins: PropTypes.arrayOf(
      PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
        id: PropTypes.number,
      })
    ).isRequired,
    pageInViewport: PropTypes.number,
    selectSpace: PropTypes.func.isRequired,
    loadPage: PropTypes.func.isRequired,
    pageForSpace: PropTypes.func.isRequired,
    spaceIsLoaded: PropTypes.func.isRequired,
    updateMapBounds: PropTypes.func.isRequired,
    selectedSpaceID: PropTypes.number,
    setMapInContainer: PropTypes.func.isRequired,
    toggleMap: PropTypes.func.isRequired,
  };

  componentDidMount() {
    // IE9 does not support classList
    if (document) document.documentElement.className += "pg-srp-index";
    this.setupMap();
  }

  componentWillUnmount() {
    this.props.setMapInContainer(null);
  }

  setupMap() {
    if (window) {
      this.map = new Map({
        container: "#srp-gmap",
        center:
          this.props.pins.length > 0
            ? [this.props.pins[0].lng, this.props.pins[0].lat]
            : [0, 0],
      });

      this.props.setMapInContainer(this);

      this.loadMarkers();
    }
  }

  async loadMarkers() {
    if (!this.map) return;

    const { selectedSpaceID, pins } = this.props;
    // console.log(`%cloadMarkers ${pins.length}`, 'color: grey;font-size:11px')
    this.map.clearMarkers();

    if (pins.length === 0) return;

    // const [firstPin] = pins
    // const bounds = pins.reduce(
    //   (bounds, coord) => bounds.extend([coord.lng, coord.lat]),
    //   new window.mapboxgl.LngLatBounds(firstPin, firstPin)
    // )
    // console.log(pins)
    // eslint-disable-next-line compat/compat
    await Promise.all(
      pins.map(async ({ lat, lng, id }) => {
        const { element } = await this.map.marker({
          lat,
          lng,
          onClick: () => this.selectMarker(id),
        });
        // console.log(`%cMarker ${lat},${lng} drawn`, 'color: grey;font-size:11px')
        // const marker = new window.mapboxgl.Marker(document.createElement('div'))
        //   .setLngLat([lng, lat])
        //   .addTo(this.map)

        // const markerEl = marker.getElement()
        // markerEl.addEventListener('click', () => this.selectMarker(id))
        if (selectedSpaceID === id) element.classList.add("hover");

        const spaceTile = document
          ? document.querySelector(`.space-tile[data-id="${id}"]`)
          : null;
        if (spaceTile) {
          spaceTile.addEventListener("mouseenter", () =>
            element.classList.add("hover")
          );
          spaceTile.addEventListener("mouseleave", () =>
            element.classList.remove("hover")
          );
        }
      })
    );
    this.map.fitMarkers();
    // const minLng = 0.01
    // if (bounds.getEast() - bounds.getWest() < minLng) {
    //   const center = bounds.getCenter()
    //   bounds.extend([center.lng + (minLng / 2), center.lat])
    //   bounds.extend([center.lng - (minLng / 2), center.lat])
    // }
    // this.map.fitBounds(bounds, { padding: 20, duration: 100 })
  }

  async selectMarker(spaceID) {
    const { selectSpace, spaceIsLoaded, pageForSpace, loadPage } = this.props;

    if (!spaceIsLoaded(spaceID)) {
      await loadPage(pageForSpace(spaceID));
    }

    selectSpace(spaceID);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.pageInViewport === this.props.pageInViewport &&
      deepEqual(prevProps.pins, this.props.pins) &&
      prevProps.selectedSpaceID === this.props.selectedSpaceID
    )
      return;
    if (window) this.loadMarkers();
  }

  refineSearch() {
    const { region, centre } = this.map.mapBounds();
    this.props.updateMapBounds(region, centre);
  }

  expandMap() {
    $("body").toggleClass("ux-srp-expanded");
    this.props.toggleMap();
    this.map.resize();
  }

  render() {
    if (typeof window === "undefined") return null;

    return (
      <>
        <div className="srp-map-overlay">
          <button
            className={cl("js-refine-search")}
            onClick={() => this.refineSearch()}
          >
            Update Results
          </button>
          <button className="js-expand" onClick={() => this.expandMap()}>
            <span className="js-expand-text-expand">Expand Map</span>
            <span className="js-expand-text-reduce">Reduce Map</span>
          </button>
        </div>
        <div className="srp-map">
          <div id="srp-gmap" />
        </div>
      </>
    );
  }
}

function mapResultsForPage(query, data, page) {
  let pages;
  if (data.pages === 1) {
    pages = [1];
  } else {
    let startPage = page === data.pages ? data.pages - 2 : page - 1;
    if (startPage < 1) startPage = 1;
    pages = [startPage, startPage + 1, startPage + 2].filter(
      (page) => page <= data.pages
    );
  }
  return pages
    .map((page) => data.map_results[page])
    .flat()
    .filter(Boolean);
}

const MapContainer = () => (
  <div className="srp-map-container square">
    {window ? (
      <Subscribe to={[SrpContainer]}>
        {({
          state: { query, data, pageInViewport, selectedSpaceID },
          selectSpace,
          loadPage,
          spaceIsLoaded,
          updateMapBounds,
          setMap,
        }) => {
          const pins = mapResultsForPage(query, data, pageInViewport) || [];
          return (
            <SrpContext.Consumer>
              {({ mapOpen, setMapOpen }) => (
                <MapController
                  pins={pins}
                  pageForSpace={(spaceID) =>
                    Object.entries(data.map_results).find(([, spaces]) =>
                      spaces.some((s) => s.id === spaceID)
                    )[0]
                  }
                  pageInViewport={pageInViewport}
                  selectSpace={selectSpace}
                  spaceIsLoaded={spaceIsLoaded}
                  loadPage={loadPage}
                  updateMapBounds={updateMapBounds}
                  selectedSpaceID={selectedSpaceID}
                  setMapInContainer={setMap}
                  toggleMap={() => setMapOpen(!mapOpen)}
                />
              )}
            </SrpContext.Consumer>
          );
        }}
      </Subscribe>
    ) : null}
  </div>
);

export default MapContainer;
